const blog = () => {
    if (document.body.classList.contains("blog") || document.body.classList.contains("category")) {
      const blogItems = document.querySelectorAll(".blog__item");
  
      if (blogItems.length > 0) {
        let maxHeight = 0;
  
        // First loop: find max height
        blogItems.forEach((item) => {
          const header = item.querySelector(".blog__item__header");
          header.style.height = "auto"; // Reset to natural height
          if (header.offsetHeight > maxHeight) {
            maxHeight = header.offsetHeight;
          }

        });
  
        // Second loop: set all headers to max height
        blogItems.forEach((item) => {
          const header = item.querySelector(".blog__item__header");
          header.style.height = `${maxHeight}px`;
        });
      }
    }
  };
  
  export default blog;
  